import { makeStyles } from 'tss-react/mui';

const useStylesToolbar: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  toolbar: {
    justifyContent: 'space-between',
    minHeight: '64px !important',
    paddingLeft: '0 !important',
    paddingRight: '0 !important',
    '& > div': {
      display: 'flex',
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: '5px !important',
      paddingLeft: '15px !important',
    },
  },
}));

export default useStylesToolbar;
